/* eslint-disable */
export default {
  matched: 'Correspondência',
  other: 'Outro',
  associated: 'Associado',
  foundFromServer: 'Encontrado em {appName}',
  recently: 'Recentes',
  additionalLabelAccount: 'Conta: {displayName}',
  additionalLabelContact: 'Contato: {displayName}',
  notFound: 'N/D',
} as const;

// @key: @#@"matched"@#@ @source: @#@"Matched"@#@
// @key: @#@"other"@#@ @source: @#@"Other"@#@
// @key: @#@"associated"@#@ @source: @#@"Associated"@#@
// @key: @#@"foundFromServer"@#@ @source: @#@"Found from {appName}"@#@
// @key: @#@"recently"@#@ @source: @#@"Recent"@#@
// @key: @#@"additionalLabelAccount"@#@ @source: @#@"Account: {displayName}"@#@
// @key: @#@"additionalLabelContact"@#@ @source: @#@"Contact: {displayName}"@#@
// @key: @#@"notFound"@#@ @source: @#@"N/A"@#@
